/* 进入游戏后活动SDK相关需求 */
import _ from 'lodash';
import { voucherList, usedVoucherList, invalidVoucherList, payVoucherList, showVoucherList } from '@/api/pay'; 

const state = {
  showList: [],
  effectiveList: [],
  usedList: [],
  invalidList: [],
  payList: [],
  voucherPacketVisible: false,
  voucherHintVisible: false
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  }
};

const actions = {
  // 有效代金券列表
  async getEffectiveList({ commit, rootState }, params) {
    const { user_id, appkey, game_version, access_token } = rootState.user;
    const data = { user_id, appkey, game_version, access_token };
    console.log(data)
    const r = await voucherList(data);
    commit('CHANGE_STATE', {
      effectiveList: r.content
    });
  },
  // 使用记录
  async getUsedList({ commit, rootState }, params) {
    const { user_id, appkey, access_token } = rootState.user;
    const data = { user_id, appkey, access_token };
    const r = await usedVoucherList(data);
    commit('CHANGE_STATE', {
      usedList: r.content
    });
  },
  // 失效代金券列表
  async getInvalidList({ commit, rootState }, params) {
    const { user_id, appkey, access_token } = rootState.user;
    const data = { user_id, appkey, access_token };

    const r = await invalidVoucherList(data);
    commit('CHANGE_STATE', {
      invalidList: r.content
    });
  },
  // 支付界面代金券列表
  async getPayList({ commit, rootState }, params = {}) {
    const { user_id, appkey, access_token, game_version } = rootState.user;
    const data = { user_id, appkey, access_token, game_version, money: params.money };

    const r = await payVoucherList(data);
    commit('CHANGE_STATE', {
      payList: r.content
    });
    return r.content
  },
  // 判断是否有新增代金券
  async getShowList({ commit, rootState }, params = {}) {
    const { user_id, appkey, access_token, game_version } = rootState.user;
    const data = { user_id, appkey, access_token, game_version };

    const r = await showVoucherList(data);
    commit('CHANGE_STATE', {
      showList: r.content,
      voucherHintVisible: !!r.content.length
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
